import { database } from './';

export const getUserRoomLinksForRoomId = (roomId: string) => {
    return database.ref('userRoomLinks').orderByChild('roomId').startAt(roomId).endAt(roomId);
};
/*
        .get()
        .then((querySnapshot) => {
            console.log(querySnapshot);
            // Get all the user ids now
            return Promise.all(
                querySnapshot.docs.map((document) => {
                    const userId = document.get('userId');
                    return firestore.collection('user').doc(userId);
                }),
            );
        });
 */
